<app-banner></app-banner>
<div class="navbar">
 <div class="navlist"> 
    <ul>
       <li><a id="home" routerLink="/home">HOME</a> </li>
       <li><a routerLink="/about">ABOUT</a></li>
       <li><a routerLink="/membership">MEMBERSHIP</a></li>
       <li><a routerLink="/calendar" >CALENDAR</a></li>
       <li><a routerLink="/multimedia" >MULTIMEDIA</a></li>
       <li><a routerLink="/contact" >CONTACT US</a></li>
       <li><a routerLink="/donate" >DONATE</a></li>
    </ul>
 </div>
</div>
 
 <div class="mobile-media">
   <a class="home" routerLink="/home" style="color: #650006;">HOME</a>
   <span class="cursor"style="font-size:15px;cursor:pointer; color: #650006;" (click)="openNav()">&#9776;</span>
 </div>


 <div #navRef id="mySidenav" class="sidenav">
    <a href="javascript:void(0)" class="closebtn" (click)="closeNav()">&times;</a>
    <div class="nav-container" style="display:flex; flex-direction: column;" (click)="closeNav()">
      <li><a routerLink="/home">HOME</a></li>
      <li><a routerLink="/about">ABOUT</a></li>
      <li><a routerLink="/membership">MEMBERSHIP</a></li>
      <li><a routerLink="/calendar">CALENDAR</a></li>
      <li><a routerLink="/multimedia">MULTIMEDIA</a></li>
      <li><a routerLink="/contact">CONTACT US</a></li>
      <li><a class="donate-here" routerLink="/donate" >DONATE HERE</a></li>
    </div>
 </div>